const AuxContainer = props => props.children
export default AuxContainer


// WEBPACK FOOTER //
// ./src/containers/AuxContainer.js